// extracted by mini-css-extract-plugin
module.exports = {"textModuleContainer":"TextModule_textModuleContainer__307dU"};